import {createContext} from 'react'

type ChangeBuildsContextType = {
  pageSize: number
  withInfiniteScroll: boolean
}

const PAGE_SIZE = 100

const DEFAULT_CHANGE_BUILDS_CONTEXT = {
  pageSize: PAGE_SIZE,
  withInfiniteScroll: false,
}

export const ChangeBuildsContext = createContext<ChangeBuildsContextType>(
  DEFAULT_CHANGE_BUILDS_CONTEXT,
)
